export default __webpack_public_path__ + "static/media/happy.668bcb90.png";